import { TimelineEvent, TimelineStep } from "@deligoo/shared"
import { useTranslation } from "react-i18next"

type EventsTimelineProps = {
  events: TimelineEvent[] | "loading" | "error"
  textKey: (event: TimelineEvent) => string
  parameters: (event: TimelineEvent, paramCls: string) => React.ReactNode
}

export const EventsTimeline = ({ events, textKey, parameters }: EventsTimelineProps) => {
  const { t } = useTranslation()

  if (events === "loading") return <span>{t("loading_data")}...</span>
  if (events === "error") return <span>{t("error_loading_data")}</span>

  if (!Array.isArray(events)) return null
  if (!events.length) return <span>Brak wydarzeń</span>

  return (
    <>
      {events.map((event) => (
        <TimelineStep key={`${event.key}${event.created_at}`} event={event} textKey={textKey} parameters={parameters} />
      ))}
    </>
  )
}
